import { render, staticRenderFns } from "./AcciLogo.vue?vue&type=template&id=05a70a12&"
import script from "./AcciLogo.vue?vue&type=script&lang=js&"
export * from "./AcciLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports